<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm10 md8 lg6>
      <v-card class="elevation-12" align-center justify-center>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Vendor Registration</v-toolbar-title>
        </v-toolbar>
        <v-img
          src="/static/img/logo.png"
          height="150"
          contain
        ></v-img>

        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
        <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.name"
                    label="Company"
                    ref="focusName"
                    :rules="[v => !!v || 'Company is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.address"
                    label="Address"
                    :rules="[v => !!v || 'Address is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="editedItem.city"
                        label="City"
                        :rules="[v => !!v || 'City is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3>
                      <v-text-field
                        v-model="editedItem.state"
                        label="State/Province"
                        :rules="[v => !!v || 'State/Province is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3>
                      <v-text-field
                        v-model="editedItem.zip"
                        label="Postal Code"
                        :rules="[v => !!v || 'Postal Code is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="editedItem.phone"
                        label="Phone"
                        :rules="[v => !!v || 'Phone is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="editedItem.country"
                        label="Country"
                        :rules="[v => !!v || 'Country is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.webSite"
                    label="Website"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="editedItem.profile"
                    label="Company Profile, Booth Size, Power Requirement and Product Description"
                    prepend-icon="notes"
                    :rules="[v => !!v || 'Company Profile is required']"
                    required
                  ></v-textarea>
                </v-flex>
                <v-flex class="title text-xs-center mt-4" xs12>
                  <span class="blue--text">PRIMARY CONTACT</span>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.firstName"
                    @keyup.enter="save"
                    label="First Name"
                    :rules="[v => !!v || 'First Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.lastName"
                    @keyup.enter="save"
                    label="Last Name"
                    :rules="[v => !!v || 'Last Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="editedItem.contactPhone"
                    label="Phone"
                    prepend-icon="phone"
                    :rules="[v => !!v || 'Phone is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.title"
                    label="Title"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="editedItem.mobile"
                    label="Mobile"
                    prepend-icon="stay_current_portrait"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    prepend-icon="email"
                    label="Email"
                    type="email"
                    v-model="editedItem.email"
                    :rules="emailRules"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          <v-alert :value="error" type="warning" transition="scale-transition">
            <span v-html="error"></span>
          </v-alert>

        <div class="subheading mx-4 text-xs-center">
          <p>
            Once submitted, you will be contacted by our Vendor Committee.<br />
            <strong>NO DEPOSIT WITH APPLICATION!</strong>
          </p>
        </div>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="save">Submit Application</v-btn>
        </v-card-actions>
      </v-form>
      </v-card>
    </v-flex>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import moment from 'moment'

export default {
  data () {
    return {
      valid: true,
      currentYear: 0,
      checkbox: false,
      editedItem: {
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      error: null,
      snackbar: {
        show: false,
        color: '',
        message: ''
      }
    }
  },

  created () {
    this.getDate()
  },

  methods: {
    getDate () {
      let currentYear = moment().format('YYYY')
      let nextYear = moment()
        .add(1, 'years')
        .format('YYYY')
      let currentDate = moment().format('MM')

      if (currentDate >= 7) {
        this.currentYear = nextYear
      } else {
        this.currentYear = currentYear
      }
    },

    async save () {
      try {
        this.editedItem.year = this.currentYear
        this.editedItem.new = 'Yes'

        console.log(this.editedItem)

        if (this.$refs.form.validate()) {
          const response = await Api().post('vendor_registration', this.editedItem)
          console.log(response.data)

          this.snackbar.message = 'Congratulation, your registration has been submitted!'
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } else {
          this.snackbar.message = 'You have some errors on the page!'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/vendor/ExternalForm.vue